import React, { Component } from 'react';
import './wrapper-total.style.css';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TableLengthBySize from './table-lenght-by-size/table-length-by-size.component';
import TableLengthByType from './table-length-by-type/table-length-by-type.component';


export class WrapperTotal extends Component {
    render() {
        return (
            <div className="wrapper-total">
                <div className="container-name-total-and-export-excel-button">
                    <h1 className="name-element-total-box">Total</h1>
                    {/* <button className="button-export-excel w-button">Export to excel</button> */}
                </div>
                <div className="container-tab-table-total">
                    <Tabs defaultActiveKey="length-by-type" id="uncontrolled-tab-example">
                        <Tab eventKey="length-by-type" title="Length by type">
                            <div className="wrapper-table-total-pipeline">
                                <TableLengthByType 
                                dataLengthByType={this.props.dataLengthByType}
                                loading={this.props.loading}
                                hasData={this.props.hasData}></TableLengthByType>
                            </div>
                        </Tab>
                        <Tab eventKey="length-by-size" title="Length by size">
                            <div className="wrapper-table-total-pipeline">
                                <TableLengthBySize 
                                dataLengthBySize={this.props.dataLengthBySize}
                                loading={this.props.loading}
                                hasData={this.props.hasData}></TableLengthBySize>
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default WrapperTotal
